import { Container } from '@/components/utils'
import { Button } from '@/components/elements/Button'

export interface FaqCTAProps {
  title: string
  subtitle: string
  ctaUrl?: string
  ctaLabel?: string
}

export const FaqCTA: React.FC<FaqCTAProps> = ({
  title,
  subtitle,
  ctaUrl,
  ctaLabel,
}) => {
  return (
    <section className="relative py-24 text-center bg-navy">
      <Container>
        <p className="mb-4 text-white font-bold tracking-wide uppercase">
          {title}
        </p>
        <h3 className="mb-10 mt-4 mx-auto max-w-5xl text-white font-display text-3xl font-black leading-tight">
          {subtitle}
        </h3>
        {ctaLabel && ctaUrl && (
          <div className="flex justify-center mt-10">
            <Button href={ctaUrl} label={ctaLabel} />
          </div>
        )}
      </Container>
    </section>
  )
}
